

export const SecctionContainer  = (props) => (<div style={{display: 'flex', flexDirection: 'column', height: '100%'}} {...props} />)